module.exports = __webpack_public_path__ + "static/media/template.c1a5298f.md";


//////////////////
// WEBPACK FOOTER
// ./src/static/reading/template.md
// module id = 850
// module chunks = 0